<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M19.7778 2H4.22222C3 2 2 3 2 4.22222V19.7778C2 21 3 22 4.22222 22H19.7778C21 22 22 21 22 19.7778V4.22222C22 3 21 2 19.7778 2Z"
    />
    <circle cx="12" cy="9" r="3" :fill="iconColor" />
    <mask
      :id="maskId"
      mask-type="alpha"
      maskUnits="userSpaceOnUse"
      x="4"
      y="14"
      width="16"
      height="5"
    >
      <rect x="4" y="14" width="16" height="5" :fill="iconColor" />
    </mask>
    <g :mask="'url(#' + maskId + ')'">
      <ellipse cx="12" cy="19" rx="6" ry="5" :fill="iconColor" />
    </g>
  </g>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

let iconHumanMaskSeq = 0;

@Options({
  props: {
	iconColor: { type: String, default: "#ffffff" }
  }
})
export default class IconHumanWithOutline extends Vue {
  iconColor!: string;
  maskId = `icon-human-${++iconHumanMaskSeq}`;
}
</script>
